module.exports = __webpack_public_path__ + "static/img/2501_phase_function_Paper_Points.0d1747b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2501_phase_function_Paper_Points.png
// module id = +Ta0
// module chunks = 0